import React, { useEffect } from 'react';
import {Route, Routes} from "react-router-dom";
import RequireAuth from "./hoc/RequireAuth";
import AdminRoutes from "./routes/AdminRoutes";
import { useDispatchEx, useSelectorEx } from './hooks/redux';
import { asyncCheckAction } from './redux/slices/auth/authAction';
import Login from "./pages/Admin/Login";
import FinancePage from "./pages/Admin/FinancePage";
import UsersPage from "./pages/Admin/UsersPage";
import {ToastContainer} from "react-toastify";

function App() {
    const dispatch = useDispatchEx();
    const {user} = useSelectorEx(state => state.auth);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && !user) {
            dispatch(asyncCheckAction());
        }
    }, [dispatch, user]);
  return (
    <>
      <ToastContainer />
      <Routes>
          <Route path="/" element={<Login/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route element={<RequireAuth role={"ADMIN"} />}>
              <Route path="/admin" element={<AdminRoutes />}>
                  <Route path="finance">
                      <Route path="page/:pageNumber" element={<FinancePage/>} />
                      <Route index element={<FinancePage/>} />
                  </Route>
                  <Route path="users">
                      <Route path="page/:pageNumber" element={<UsersPage/>} />
                      <Route index element={<UsersPage/>} />
                  </Route>
                  <Route index element={<FinancePage />} />

              </Route>
          </Route>
      </Routes>
    </>
  );
}

export default App;
